import React from 'react';
import { Col, Icon, Row } from 'straightline-ui';
import { formatMoney, roundNumberToLabel } from 'straightline-utils/accounting';
import { isExpired, isLTL } from 'straightline-utils/constants';

export default function QuoteBanner({ quote }) {
  const offer = quote.offers && quote.offers[0];

  return (
    <Row className="justify-content-between align-items-center mb-n2">
      <Col xs="auto" className="mb-2">
        <Price quote={quote} offer={offer} />
      </Col>
      <Col xs="auto" className="text-md-right mb-2">
        <div className="text-secondary">
          {isLTL(quote.mode) ? 'LTL' : quote.truck.label}
          <Icon type="dot" className="text-muted mx-1" />
          {roundNumberToLabel(quote.load_weight)} lbs
        </div>
        <div className="text-secondary">
          {quote.travel.miles} mi
          {quote.rate && (
            <React.Fragment>
              <Icon type="dot" className="text-muted mx-1" />
              {formatMoney(quote.rate.price.shipper_price / quote.travel.miles)}
              /mi
            </React.Fragment>
          )}
        </div>
      </Col>
    </Row>
  );
}

const Tag = ({ del = false, ...props }) => {
  return del ? <del {...props} /> : <span {...props} />;
};

export const Amount = ({ del = false, min, max }) => {
  return min === max ? (
    <div>
      $<Tag del={del}>{formatMoney(min, { precision: 0, symbol: '' })}</Tag>
    </div>
  ) : (
    <div>
      $<Tag del={del}>{formatMoney(min, { precision: 0, symbol: '' })}</Tag> - $
      <Tag del={del}>{formatMoney(max, { precision: 0, symbol: '' })}</Tag>
    </div>
  );
};

const Price = ({ quote, offer }) => {
  if (quote.rate) {
    return (
      <div
        className="h1 mb-0 text-success"
        style={{ fontSize: 35, lineHeight: 1 }}
      >
        {formatMoney(quote.rate.price.shipper_price, { precision: 0 })}
      </div>
    );
  }

  const { min, max } = quote.rates_range;

  if (isExpired(quote)) {
    return (
      <div
        className="h1 mb-0 text-danger"
        style={{ fontSize: 35, lineHeight: 1, opacity: 0.6 }}
      >
        <Amount del min={min} max={max} />
      </div>
    );
  }

  if (!offer) {
    return (
      <div
        className="h1 mb-0 text-primary"
        style={{ fontSize: 35, lineHeight: 1 }}
      >
        <Amount min={min} max={max} />
      </div>
    );
  }

  if (offer.accepted_at) {
    return (
      <div
        className="h1 mb-0 text-primary"
        style={{ fontSize: 35, lineHeight: 1 }}
      >
        {formatMoney(offer.amount, { precision: 0 })}
      </div>
    );
  }

  return (
    <div
      className="h1 mb-0 text-primary"
      style={{ fontSize: 35, lineHeight: 1, opacity: 0.6 }}
    >
      <Amount min={min} max={max} />
    </div>
  );
};
